<template lang="pug">
  #app
    GH
    transition(mode="out-in")
      router-view
    GF
</template>


<script>
// @ is an alias to /src
import GH from '@/components/GlobalHeader.vue'
import GF from '@/components/GlobalFooter.vue'

export default {
  name: 'home',
  components: {
    GH, GF
  },
  mounted(){
    this.$store.dispatch('ixa/setWinningNumber') 
  }
}
</script>


<style lang="sass">
@import "~bulma/sass/utilities/_all"
$primary: #BA221E
$primary-invert: findColorInvert($primary)
$primary-hover: rgb(133, 41, 38)
$twitter: #4099ff
$twitter-invert: findColorInvert($twitter)
$colors: ( "white": ( $white, $black), "black": ( $black, $white), "light": ( $light, $light-invert), "dark": ( $dark, $dark-invert), "primary": ( $primary, $primary-invert), "info": ( $info, $info-invert), "success": ( $success, $success-invert), "warning": ( $warning, $warning-invert), "danger": ( $danger, $danger-invert), "twitter": ( $twitter, $twitter-invert))
$link: $primary
$link-invert: $primary-invert
$link-focus-border: $primary

@font-face
  font-family: "materialdesignicons"
  src: url("/fonts/materialdesignicons-webfont.woff2") format("woff2"), url("/fonts/materialdesignicons-webfont.woff") format("woff")

@import "~bulma"
@import "~buefy/src/scss/buefy"
.snackbar.is-warning.is-bottom
  position: fixed!important

html, body 
  height: 100%

#app 
  height: 100%!important

.numberListContainer 
  .field
    display: flex
    flex-wrap: wrap
    .control
      margin: 3px!important
      .b-checkbox.checkbox.button.is-small
        min-width: 60px!important
        border-radius: 0!important
  &.loto6
    .field
      .control
        .b-checkbox.checkbox.button.is-small
          min-width: 170px!important
  &.loto6.mobile
    .field
      justify-content: center
  &.loto7
    .field
      .control
        .b-checkbox.checkbox.button.is-small
          min-width: 190px!important
  &.loto7.mobile
    .field
      justify-content: center
      .control
        .b-checkbox.checkbox.button.is-small
          padding-left: 0
          padding-right: 0


.toast.is-primary.is-bottom
  position: fixed

.notices.is-bottom.has-custom-container
  .toast.is-primary.is-bottom
    bottom: 60px
    div
      font-size: 0.8rem!important

</style>
<style lang="stylus">
.v-enter
  transform: translate(100px, 0)
  opacity: 0
.v-enter-to
  opacity: 1
.v-enter-active
  transition: all 1s 0s ease
.v-leave
  transform: translate(0, 0)
  opacity: 1
.v-leave-to
  transform: translate(-100px, 0)
  opacity: 0
.v-leave-active
  transition: all .5s 0s ease
</style>